$(function () {
    var $scrollTop = $(".scrollTop"),
        $socialIcons = $(".social-icon-popup"),
        speed = 500,
        $window = $(window),
        $document = $(document);

    $scrollTop.on("click", function () {
        $("html:not(:animated),body:not(:animated)").animate({ scrollTop: 0 }, speed);
        return false;
    });

    function showScrollTop() {
        ($window.scrollTop() > 300) ? $scrollTop.fadeIn(600) : $scrollTop.hide();
    }

    function moveSocialIcons() {
        if ($window.scrollTop() + $window.height() > $document.height() - 100) {
            $socialIcons.css("top", "30%");
        } else {
            $socialIcons.css("top", "50%");
        }
    }

    $window.on("scroll", function () {
        showScrollTop();
        moveSocialIcons();
    });

    showScrollTop();
    moveSocialIcons();
});
